import { useMutation } from '@tanstack/react-query';
import apiService from '../services/apiService';

export const useDeleteFeature = () => {
  return useMutation({
    mutationFn: async ({ propertyId, featureId }) => {
      const response = await apiService.delete(
        `/api/properties/${propertyId}/features/${featureId}`
      );
      return response.data;
    },
  });
};
